/**
 * Profile tab registry.
 *
 * Single source of truth for the profile page's tab groups, role-aware. The
 * ProfilePage stays dumb — it renders this list as a pill tab bar (mirroring
 * AdminDashboardPage) and shows only the active tab's section(s). Adding a
 * section, re-grouping, or re-ordering is a change here only.
 *
 * Every section component receives `{ user }` as props.
 *
 *   Account:        Identity + ONE role-specific section
 *                     professional → Professional Details
 *                     corporate    → Organization
 *                     admin/super  → Role & Permissions
 *   Notifications:  Notification Preferences   (all roles)
 *   Security:       Password + 2FA status + Devices & Sessions   (all roles)
 *   Activity:       Own recent account activity (self-scoped audit)   (all roles)
 *   Privacy:        Privacy & Consent + AI data controls   (all roles)
 */

import { FiUser, FiBell, FiShield, FiLock, FiActivity } from 'react-icons/fi';
import IdentitySection from './IdentitySection';
import ActivitySection from './ActivitySection';
import ProfessionalSection from './ProfessionalSection';
import OrganizationSection from './OrganizationSection';
import RolePermissionsSection from './RolePermissionsSection';
import SecuritySection from './SecuritySection';
import PrivacyConsentSection from './PrivacyConsentSection';
import NotificationPreferencesSection from './NotificationPreferencesSection';

export function getProfileTabs(roleName) {
  const role = String(roleName || '').toLowerCase();

  // Account tab = identity plus the single role-specific section (if any).
  const account = [{ key: 'identity', Component: IdentitySection }];
  if (role === 'professional') {
    account.push({ key: 'professional', Component: ProfessionalSection });
  } else if (role === 'corporate') {
    account.push({ key: 'organization', Component: OrganizationSection });
  } else if (role === 'admin' || role === 'super_admin') {
    account.push({ key: 'role-permissions', Component: RolePermissionsSection });
  }

  return [
    { id: 'account', label: 'Account', icon: FiUser, sections: account },
    { id: 'notifications', label: 'Notifications', icon: FiBell, sections: [{ key: 'notifications', Component: NotificationPreferencesSection }] },
    { id: 'security', label: 'Security', icon: FiShield, sections: [{ key: 'security', Component: SecuritySection }] },
    { id: 'activity', label: 'Activity', icon: FiActivity, sections: [{ key: 'activity', Component: ActivitySection }] },
    { id: 'privacy', label: 'Privacy', icon: FiLock, sections: [{ key: 'privacy', Component: PrivacyConsentSection }] },
  ];
}
